import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
import { getExtSensorsStatus } from '../helpers/ext_sensor_helpers';
import { isEmeterWithRelay, isThreeEM, is_gen_2 } from '../helpers/interface_helpers';
import { filter_mobile_alarms_data } from '../helpers/utilities';
import type { NativeHomesPayload, NativeProfilesPayload } from '../helpers/native_bridge_helpers';

export function set_devices_data_ios(user_data, devices) {
	fetch(
		'shelly://device_list/?d=' +
			encodeURIComponent(
				JSON.stringify({
					userdata: user_data,
					devices: edit_mobile_devices_data(devices),
				}),
			),
		{
			method: 'get',
		},
	);
}

export function set_rooms_data_ios(rooms) {
	fetch('shelly://room_list/?r=' + encodeURIComponent(JSON.stringify(edit_mobile_rooms_data(rooms))), {
		method: 'get',
	});
}

export function set_scenes_data_ios(scenes) {
	fetch(
		'shelly://scene_list/?s=' +
			encodeURIComponent(JSON.stringify(filter_mobile_scenes_data(scenes))),
		{
			method: 'get',
		},
	);
}

export function set_alarms_data_ios(scenes) {
	fetch(
		'shelly://alarms_list/?a=' +
			encodeURIComponent(JSON.stringify(filter_mobile_alarms_data(scenes))),
		{
			method: 'get',
		},
	);
}

export function set_groups_data_ios(groups) {
	fetch(
		'shelly://group_list/?r=' + encodeURIComponent(JSON.stringify(edit_mobile_groups_data(groups))),
		{
			method: 'get',
		},
	);
}

export function set_profiles_data_ios(payload: NativeProfilesPayload) {
	fetch('shelly://profiles_info/?p=' + encodeURIComponent(JSON.stringify(payload)), {
		method: 'get',
	});
}

export function set_homes_data_ios(homes: NativeHomesPayload) {
	fetch('shelly://homes_list/?h=' + encodeURIComponent(JSON.stringify(homes)), {
		method: 'get',
	});
}

export function home_switched_ios(unitId: string, subId?: string) {
	const subParam = subId ? `&sub=${encodeURIComponent(subId)}` : '';
	fetch(`shelly://home_switched/?id=${encodeURIComponent(unitId)}${subParam}`, {
		method: 'get',
	});
}

function filter_mobile_scenes_data(scenes) {
	const filtered_scenes = {};
	for (const k in scenes) {
		if (Object.prototype.hasOwnProperty.call(scenes, k)) {
			const v = scenes[k];
			if (!v.hasOwnProperty('_gui_function') && !v.hasOwnProperty('tschem')) {
				// Double check for missing properties in _meta or even the whole _meta object
				// in the scene fixing process on load does not work as expected.
				if (v?._meta) {
					filtered_scenes[k] = {};
					if (v?._meta?.room !== undefined) {
						filtered_scenes[k].room = v._meta.room !== null ? v._meta.room.toString() : -1;
					}
					if (v?._meta?.name !== undefined) {
						filtered_scenes[k].name = v._meta.name !== null ? v._meta.name : '';
					}
					if (v?._id !== undefined) {
						filtered_scenes[k].id = v._id.toString();
					}
					if (v?._meta?.position !== undefined) {
						filtered_scenes[k].position = v._meta.position;
					}
				}
			}
		}
	}
	return filtered_scenes;
}

const local = ['images/room_def/', 'images/device_images/', 'images/home_def', 'hom_def'];

function edit_mobile_devices_data(devices) {
	// !!!!!! Very important to keep this function.
	// !!!!!! Never remove this function!!!
	// The problem is that for IOS devices the interface data must be with specific structure. Values like null are invalid.
	// But since we have advanced or power users they can use custom apps or scripts, where this data structure can be different.
	// This will break the App on IOS.
	const edited_devices = {};
	for (const k in devices) {
		if (Object.prototype.hasOwnProperty.call(devices, k)) {
			const v = devices[k];

			const isGen2 = is_gen_2(v);

			const addonPeripherals = isGen2 ? getAddonStatus(v) : getExtSensorsStatus(v);

			edited_devices[k] = {};
			edited_devices[k].id = v.id;
			edited_devices[k].channel = v.channel;

			edited_devices[k].name = v.name;
			edited_devices[k].type = v.type;
			edited_devices[k].category = v.category;
			edited_devices[k].room_id = Number(v.room_id);
			edited_devices[k].position = v.position;
			edited_devices[k].gen = v.gen + '';

			if (v.server) {
				edited_devices[k].server = v.server;
			}
			//Adding ht_ui for ble ht devices
			if (v.hasOwnProperty('ht_ui')) {
				edited_devices[k].ht_ui = v.ht_ui;
			}

			if (v.category === 'emeter') {
				if (isThreeEM(v.type)) {
					if ((v.mode && /^(triphase|emeter)$/.test(v.mode)) || v.type === 'SHEM-3') {
						edited_devices[k].phases = 3;
					}
					// } else if (v.type === 'SPEM-002CEBEU50') {
					// 	edited_devices[k].phases = 2;
				} else {
					edited_devices[k].phases = 1;
				}

				if (isEmeterWithRelay(v)) {
					edited_devices[k].has_switch = true;
				}
			}

			if (addonPeripherals.length > 0) {
				let iOSAddonsData = addonPeripherals.map((addon) => {
					if (isGen2) {
						return {
							name: addon.sensor.name,
							type: addon.sensor.type,
							component: addon.sensor.component,
						};
					} else {
						return { name: addon.sensor.name };
					}
				});

				isGen2
					? (edited_devices[k].addons = iOSAddonsData)
					: (edited_devices[k].externals = iOSAddonsData);
			}
		}
	}
	return edited_devices;
}

function edit_mobile_rooms_data(rooms) {
	const edited_rooms = {};
	for (const k in rooms) {
		if (Object.prototype.hasOwnProperty.call(rooms, k)) {
			const v = rooms[k];

			if (typeof v.image !== 'undefined') {
				edited_rooms[k] = Object.assign({}, v);
				edited_rooms[k].image = {
					local: local.some((_uri) => v.image?.includes(_uri)),
					filepath: v.image,
				};
			}
		}
	}
	return edited_rooms;
}

function edit_mobile_groups_data(groups) {
	const edited_groups = {};
	for (const k in groups) {
		if (Object.prototype.hasOwnProperty.call(groups, k)) {
			const v = groups[k];
			edited_groups[k] = {};
			edited_groups[k].id = v.id.toString();
			edited_groups[k].room_id = v.room_id.toString();
			edited_groups[k].devices = v.devices;
			edited_groups[k].name = v.name;
			edited_groups[k].type = v.type;
		}
	}
	return edited_groups;
}
